// eslint-disable-next-line import/no-default-export
export default {
    REDUCER_KEY: "REGISTRATION",
    ENTITY_NAME: "registration",
    RESOURCE: "rent-registrations",
};
